<header>
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="row">
    <div class="col-3" style="text-align: left; margin: 5px;">
      <button type="button" class="btn btn-secondary btn-block" (click)="IrAdmininfCHV()" style="overflow: hidden; white-space: normal; max-width: 100%;">Cartera Hipotecaria de Vivienda</button>
    </div>
  </div>
  <div class="row">
    <div class="col-3" style="text-align: left; margin: 5px;">
      <button type="button" class="btn btn-secondary btn-block" (click)="IrAdmininfFIVI()" style="overflow: hidden; white-space: normal; max-width: 100%;">Financiación de Vivienda</button>
    </div>
  </div>
</body>
